import { Component, OnInit, Inject, ViewChild } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from "@angular/common/http";
import { ApiService } from "../../../api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { environment } from "../../../../environments/environment";
import { ToastService } from "@app/components/toastr/toast.service";

@Component({
  selector: "app-branch-list",
  templateUrl: "./branch-list.component.html",
  styleUrls: ["./branch-list.component.scss"],
})
export class BranchListComponent implements OnInit {
  public list = [];
  message = null;
  class = null;

  constructor(
    private router: Router,
    private api: ApiService,
    private http: HttpClient,
    private toast: ToastService,
    @Inject("API_ENDPOINT") private api_endpoint: string
  ) { }

  public settings = {
    actions: {
      position: "right",
      add: false,
      edit: false,
      delete: true,
    },
    delete: {
      confirmDelete: true,
    },
    columns: {
      name: {
        title: "Branch",
      },
      _id: {
        title: "Edit",
        type: "html",
        valuePrepareFunction: (cell, row) => {
          return `<a href="branch/edit/${row._id}"  class="ng2-smart-action ng2-smart-action-edit-edit ng-star-inserted"><i class="fa fa-pencil"></i></a>&nbsp; `;
        },
        filter: false,
      },
    },
  };

  ngOnInit() {
    this.http
      .get<any>(`${environment.apiUrl}/branch/`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
      })
      .subscribe(
        (data) => {
          data.message == "Logged Out!"
            ? this.router.navigateByUrl("/auth/login")
            : "";
          this.list = data.results;
          // console.log(data);

        },
        (err: HttpErrorResponse) => {
          if (err.error instanceof Error) {
            console.log("Client-side error occured.");
          } else {
            console.log("Server-side error occured.");
          }
        }
      );
  }

  deleteRecord(event) {
  if (confirm("Are You Sure?")) {
    this.http
      .delete<any>(`${environment.apiUrl}/branch/${event.data._id}`, {
        headers: {
          Userinfo: JSON.stringify({
            _id: localStorage.getItem("adminSess"),
            role: localStorage.getItem("userRole"),
          }),
        },
        
      })
      
      .subscribe(
        (res) => {
           this.list = this.list.filter(item => item._id !== event.data._id);
            this.list = [...this.list]; // 👈 force Angular to detect change
            this.toast.show("Successfully Deleted", "success");

          
          if (res.status == "500") {
            this.toast.show(res.message || "Failed to delete branch", "error");
          } else {
            // ✅ Remove from list directly
          

           
          }
          if (res.message === "Logged Out!") {
            this.router.navigateByUrl("/auth/login");
            return;
          }
           
          
        },
        (err: HttpErrorResponse) => {
          console.error("Error deleting branch:", err);
          this.toast.show("Server error occurred while deleting", "error");
        }
      );
  }
}



}
